import React from 'react';
import { Formik } from 'formik';
import { useQuery } from '@apollo/client';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { APP_UI, privacyValidationSchema } from 'pages/ApplicationUI/constant';
import { UI_SETTING_BY_NAME } from 'pages/ApplicationUI/ApplicationUIGraphQL';
import Loader from 'components/common/Loader';
import ErrorMessage from 'components/ErrorMessage';
import ErrorBoundary from 'components/common/ErrorBoundary';
import PrivacyPolicyForm from './components/PrivacyPolicyForm';

const PrivacyPolicy = ({ handleSubmit }) => {
  const { data, loading, error, refetch } = useQuery(UI_SETTING_BY_NAME, {
    variables: { settingName: APP_UI.PRIVACY_POLICY },
    fetchPolicy: 'network-only',
  });

  if (error) {
    return <ErrorMessage error={error} />;
  }

  return (
    <Row>
      <Col xl={12}>
        <Card className="border-0 card-box">
          <CardBody>
            <h4 className="f-16 fw-semibold mb-3">Privacy Policy</h4>
            <ErrorBoundary>
              {loading ? (
                <Loader />
              ) : (
                <Formik
                  validationSchema={privacyValidationSchema}
                  initialValues={data.findBySettingName || { settingValue: '' }}
                  onSubmit={(values) => handleSubmit(values, refetch)}
                  children={(props) => {
                    return <PrivacyPolicyForm {...props} />;
                  }}
                  enableReinitialize
                />
              )}
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
};

export default PrivacyPolicy;
